import api from "./Api";

class TicketMensagemService {
  GetTicketMensagem(payload) {
    return api.get("/v1/ticketMensagem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTicketMensagem(payload) {
    return api.post("/v1/ticketMensagem/", payload).then((response) => {
      return response.data;
    });
  }

  PutTicketMensagem(payload) {
    return api.put("/v1/ticketMensagem/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTicketMensagem(payload) {
    return api.delete("/v1/ticketMensagem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTicketMensagemOData(payload) {
    return api.get("/OData/TicketMensagem" + payload).then((response) => {
      return response.data;
    });
  }

  PostTicketMensagemUpload(payload) {
    return api.post("/v1/ticketMensagemUpload/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTicketMensagemUpload(payload) {
    return api
      .delete("/v1/ticketMensagemUpload/" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TicketMensagemService();
